var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-tag"},[(!_vm.countDownShow)?_c('div',{staticClass:"count-down-box"},[_vm._v("\n        "+_vm._s(_vm.getCountDown())+"\n    ")]):_vm._e(),(_vm.countDownShow)?_c('div',[_vm._v("已超时")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }